import { type CrudList, PastaCrudApi, useClassFactory } from "@pasta/box-v2";
import { subject } from "@casl/ability";
import { type AppNotificationDto } from "../dto/app-notification.dto";
import { type Omit } from "lodash";

export class AppNotificationApi extends PastaCrudApi<{
  Entity: AppNotificationDto;
  CreateDto: Omit<AppNotificationDto, "isRead" | "id" | "creationDate" | "modificationDate">;
}> {
  protected readonly baseEndpoint = "app-notification/";

  map<T extends AppNotificationDto>(entity: T) {
    return subject("AppNotification", entity);
  }

  async getMine(offset: number, limit: number): Promise<CrudList<AppNotificationDto> & { unread: number }> {
    return (await this.network.get(`${this.baseEndpoint}mine`, { offset, limit })).data;
  }

  async markAsRead(id: number) {
    return (await this.network.post(`${this.baseEndpoint}${id}/read`)).data;
  }

  async markAllAsRead() {
    return (await this.network.post(`${this.baseEndpoint}read`)).data;
  }

  async removeAll() {
    await this.network.delete(`${this.baseEndpoint}mine`);
  }
}

export const [AppNotificationApiToken, useAppNotificationApi] = useClassFactory(AppNotificationApi);
